import { Badge } from "@/components/ui/badge";

export const STATUS_META = {
  new: { label: "New", cls: "bg-secondary text-foreground border-border" },
  in_progress: { label: "In progress", cls: "bg-[rgba(37,99,235,0.10)] text-[#1D4ED8] border-[rgba(37,99,235,0.25)]" },
  resolved: { label: "Resolved", cls: "bg-[rgba(31,138,91,0.12)] text-[#166534] border-[rgba(31,138,91,0.25)]" },
  spam: { label: "Spam", cls: "bg-[rgba(212,33,55,0.10)] text-[#B91C1C] border-[rgba(212,33,55,0.25)]" },
};

export const StatusBadge = ({ status }) => {
  const m = STATUS_META[status] || STATUS_META.new;
  return <Badge variant="outline" className={`rounded-md font-medium ${m.cls}`} data-testid={`status-badge-${status}`}>{m.label}</Badge>;
};

export const formatDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString(undefined, { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const listToText = (arr) => (Array.isArray(arr) ? arr.join("\n") : "");
export const textToList = (txt) => (txt || "").split("\n").map((s) => s.trim()).filter(Boolean);
